import { IPhysicalService } from './IPhysicalService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, Actions, PREVILEGEKEY, PackageType } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PhysicalInventoryHeadEntity } from '../../../models/PhysicalInventory/PhysicalInventoryHeadEntity';
import { FetchAllZones, PhysicalInventoryEntity, PhysicalInventoryPostModel, PIIngListsRequestEntity, PIIngListsResponseEntity } from '../../../models/PhysicalInventory/PhysicalInventoryEntity';
import { PhysicalInventoryDetailsEntity } from '../../../models/PhysicalInventory/PhysicalInventoryDetailsEntity';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';
import { InventoryCollectionEntity } from 'src/app/shared/models/Inventory/InventoryCollectionEntity';

@Injectable({
  providedIn: 'root'
})
export class PhysicalService implements IPhysicalService {
  constructor(private httpService: HttpRequestService) { }

  /* Gets the Physical Forms */
  GetPhysicalForms(): Observable<string[]> {

    return this.httpService.GetHttpRequest(apiURLs.PhysicalInventoryAPI.GetPhysicalForms);
  }

  /* Gets Report URL for form */
  GetProcessForm(PostDate: Date, LocationId: number, FormId: string,
     Options: string, SiteId: number, PackageId?: number, TypeId?: string, ClassId?: string): Observable<string> {

    const inputParams = new HttpParams().set('PostDate', PostDate.toDateString())
      .set('LocationId', LocationId.toString())
      .set('FormId', FormId)
      .set('Options', Options)
      .set('SiteId', SiteId.toString())
      .set('PackageId', PackageId.toString())
      .set('TypeId', TypeId.toString())
      .set('ClassId', ClassId.toString())
      .set('APIKEY', PREVILEGEKEY.ProcessForm);

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PhysicalInventoryAPI.GetProcessForm);
  }

  /* Gets the Build list for Actions */
  GetBuildList(PostDate: string, LocationId: number,
    Options: string, Action: Actions, PackageId: number= 0, TypeId?: string,
    ClassId?: string, InventoryIds?: string, isCycleCount?: boolean)
    : Observable<PhysicalInventoryEntity> {
    const inputParams = new HttpParams().set('PostDate', PostDate)
      .set('LocationId', LocationId.toString())
      .set('Options', Options)
      .set('Action', JSON.stringify(Action))
      .set('PackageId', PackageId.toString())
      .set('InventoryId', InventoryIds.toString())
      .set('TypeId', TypeId.toString())
      .set('ClassId', ClassId.toString())
      .set('isCycleCount', isCycleCount.toString())
      .set('APIKEY', PREVILEGEKEY.BuildList);

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PhysicalInventoryAPI.GetBuildList);
  }
  /**
   * @version 13.2 UI 
   * @method GetPIIngLists
   * @param locationId 
   * @returns 
   */
   GetPIIngLists(PIRequestParams: PIIngListsRequestEntity):Observable<PIIngListsResponseEntity> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetPIIngLists, PIRequestParams);
  }

  PhysicalInventoryLookup (PIRequestParams: PIIngListsRequestEntity):Observable<PIIngListsResponseEntity> {
    return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetPhysicalInventoryLookup, PIRequestParams);
  }

  /* Gets the Saved Physical Inventories List */
  GetSavedPhysicalInventories(locationId?: number): Observable<PhysicalInventoryHeadEntity[]> {
    const inputParams = new HttpParams().set('locationId', locationId.toString())
    .set('APIKEY', PREVILEGEKEY.LoadSavedPhysicalInventories);

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PhysicalInventoryAPI.GetSavedPhysicalInventories);
  }

  /* Gets the saved physical Inventory items. */
  GetPhysicalInventory(PhysicalHeaderId: number): Observable<PhysicalInventoryHeadEntity[]> {

    const inputParams = new HttpParams().set('PhysicalHeaderId', PhysicalHeaderId.toString());

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PhysicalInventoryAPI.GetPhysicalInventory);
  }

  /* Checks the build adjustment */
  GetIsBuildAdjustment(physicalInventoryEntity: PhysicalInventoryEntity): Observable<string> {
    return this.httpService.GetHttpRequestId(physicalInventoryEntity, apiURLs.PhysicalInventoryAPI.GetIsBuildAdjustment);
  }

  /* Gets the post adjustment list */
  GetPostAdjustment(LocationId: number): Observable<PhysicalInventoryDetailsEntity[]> {

    const inputParams = new HttpParams().set('LocationId', LocationId.toString())
    .set('APIKEY', PREVILEGEKEY.GetPostAdjustment);

    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PhysicalInventoryAPI.GetPostAdjustment);
  }
  /**
   * @version 13.2 UI - Method Modification
   * @param physicalInventoryEntity 
   * @returns 
   */
    PhysicalInventoryPost(physicalInventoryEntity: PhysicalInventoryPostModel,isEdit:boolean, physicalHeadId:number): Observable<any> {
      if(isEdit)
        return this.httpService.putHttpRequest(apiURLs.InvertoryManagement.PostPhysicalHead + '/' + physicalHeadId, physicalInventoryEntity);
      else
        return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.PostPhysicalHead, physicalInventoryEntity);
    }

     /**
   * @version 24.1 UI - Method Modification
   * @param physicalInventoryEntity 
   * @returns 
   */
    AutoSavePhysicalInventoryPost(physicalInventoryEntity: PhysicalInventoryPostModel): Observable<any> {
        return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.AutoSavePostPhysicalHead, physicalInventoryEntity);
    }

    /**
   * @version 13.2.6 UI - Method Modification
   * @param piId 
   * @returns 
   */
    PICancel(piId): any {
      return this.httpService.deleteHttpRequest(apiURLs.InvertoryManagement.PostPhysicalHead + '/' + `'${piId}'`);
    }

  /*Posts The physical Inventory*/
  PostPhysicalInventory(physicalInventoryEntity: PhysicalInventoryEntity): Observable<ValidationEntity> {
    (physicalInventoryEntity as any).APIKEY = PREVILEGEKEY.PostPhysicalInventory;    
      return this.httpService.postHttpRequest(apiURLs.PhysicalInventoryAPI.PostPhysicalInventory, physicalInventoryEntity);    
  }

  PostFetchAllZones(FetchAllZonesEntity: FetchAllZones): Observable<any> {
      return this.httpService.postHttpRequest(apiURLs.PhysicalInventoryAPI.PostFetchAllZones, FetchAllZonesEntity);    
  }

  PostGetAllBins(FetchAllZonesEntity: FetchAllZones): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.PhysicalInventoryAPI.PostGetAllBins, FetchAllZonesEntity);    
  }
    /**
   * @version 13.2
   * @GetLoggedInLocation
   */
   GetLoggedInLocation(LocationUrl: string): Observable<any> {
    return this.httpService.GetHttpRequest(LocationUrl);
  }
    /**
   * @version 13.2 UI Modification
   * @param LocationParams
   * @returns
   */
     GetInventoryLocations(LocationParams: any): Observable<any> {
      const locationRequestUrl = apiURLs.InvertoryManagement.GetInventoryLocation + LocationParams;
      return this.httpService.GetHttpRequest(locationRequestUrl);
    }
    GetInventoryPackages(): Observable<any> {
        const packageRequestUrl = apiURLs.InvertoryManagement.GetPackages;
      return this.httpService.GetHttpRequest(packageRequestUrl);
    }

    /**
   * @version 25.2 UI Modification
   * @returns 
   */
    GetMasterData(EndPointUrl): Observable<any> {
      return this.httpService.GetHttpRequest(EndPointUrl);
    }
    
    GetPISavedData(PIHeadParams: any): Observable<any> {
      const savedPIdata = apiURLs.InvertoryManagement.GetSavedPI + PIHeadParams;
      return this.httpService.GetHttpRequest(savedPIdata);
    }    

    /**
   * @version 24.3 UI Modification
   * @param requestParams
   * @returns
   */
    GetAllPhysicalInventory(requestParams: any): Observable<any> {
      return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetAllPhysicalInventory, requestParams);    
    }

    GetSavedPIById(id: number, transTypeId:number): Observable<any> {      
      const savedPIdata = `${apiURLs.InvertoryManagement.GetPhysicalById}` + `?Id=${id}`;
      return this.httpService.GetHttpRequest(savedPIdata);
    }

    ReversePI(id: number): Observable<any> {
      const url = `${apiURLs.InvertoryManagement.ReversePhysicalInventory}`;
      return this.httpService.postHttpRequest(url, id);
    }

    GetInventoryPackageById(url: string): Observable<any> {
      return this.httpService.GetHttpRequest(url);
    }
}
